<template lang='pug' src='./contact.pug'></template>

<script>
import CustomContact from 'components/custom/custom-contact-section/custom-contact-section'
import Hero from 'components/hero/hero'
import Loader from 'components/loader/loader'
import Intro from 'components/block/block-intro/block-intro'

export default {
  name: 'contact',
  computed: {
    props () {
      return {
        ...this.$store.state.pages['contact'],
        app: {...this.$store.state.app.information}
      }
    },
    loading () {
      return this.$store.state.loading
    }
  },
  mounted () {
    console.log(this.$route.hash)
  },
  components: {
    CustomContact,
    Hero,
    Intro,
    Loader
  }
}
</script>



// WEBPACK FOOTER //
// contact.vue?5854121a